const en = {
  nav: {
    home: "Home",
    about: "About Us",
    destinations: "Destinations",
    tours: "Tours & Packages",
    gallery: "Gallery",
    testimonials: "Testimonials",
    blog: "Blog",
    contact: "Contact Us",
    experiences: "Experiences",
    vip: "VIP Business",
    vipFull: "VIP Business Travel",
    worldcup: "World Cup 2030",
    careers: "Careers",
    chatWhatsApp: "Chat on WhatsApp",
    jewishHeritage: "Kosher Travel",
    menu: "Menu"
  },
  servicePolicy: {
    meta: {
      title: "Service Policy & Responsibility",
      subtitle: "Morocco Loves You - Professional DMC & Ground Services",
      seoTitle: "Service Policy & Responsibility | Morocco Loves You",
      metaDescription: "Professional B2B DMC service policy, responsibility terms, commitments, and limitation of liability for Morocco Loves You ground services in Morocco.",
      eyebrow: "International B2B DMC",
      commitmentsTitle: "Our Commitments & Responsibilities",
      commitmentsText: "Clear operating terms for agencies, tour operators, companies, organized groups, VIP clients, and professional partners.",
      ctaEyebrow: "Partner Support",
      ctaTitle: "Need a confirmed B2B program in Morocco?",
      ctaText: "Our team is available for professional itinerary coordination, quotation support, and 24/7 ground assistance.",
      ctaButton: "Contact Our Team",
      footerLink: "Service Policy"
    },
    intro: [
      "Morocco Loves You is an international DMC company specialized in professional ground services in Morocco for travel agencies, tour operators, companies, private groups, VIP clients, and international organizations.",
      "We operate exclusively under a B2B business model."
    ],
    sections: [
      {
        title: "Service Commitment",
        text: "We are committed to delivering all services agreed upon in writing and confirmed in the signed agreement with our professional partners."
      },
      {
        title: "Our DMC Services",
        text: "Our services include hotels, transportation, tour guides, restaurants, excursions, logistics, VIP assistance, and 24/7 support."
      },
      {
        title: "Airline Tickets",
        text: "Morocco Loves You does not sell international airline tickets. We may assist with guidance and flight research, but responsibility for flights, delays, cancellations, or airline policies belongs to the airlines, travel agencies, and travelers themselves."
      },
      {
        title: "Medical & Travel Insurance",
        text: "We do not provide travel insurance or medical insurance. We strongly recommend that every traveler purchases full travel and medical insurance before arriving in Morocco."
      },
      {
        title: "Food & Catering Responsibility",
        text: "We work with recognized hotels, restaurants, and catering providers. Each establishment remains fully responsible for food quality, hygiene, freshness, food preparation, and service. Our role is to supervise and verify service quality standards. Morocco Loves You cannot be held responsible for food poisoning, allergies, digestive issues, or medical incidents related to food consumption."
      },
      {
        title: "Our Professional Responsibility",
        text: "We are responsible for respecting the confirmed itinerary, providing professional service, working with reliable hotels and partners, providing proper transportation, supplying professional multilingual guides, and supporting groups throughout their stay."
      },
      {
        title: "Tips",
        text: "Tour prices do not include tips for drivers and guides. It is customary to give up to €2.5 per traveler per day."
      },
      {
        title: "24/7 Assistance",
        text: "The Morocco Loves You team provides support 24/7 via phone, WhatsApp, and messaging services."
      },
      {
        title: "Limitation of Liability",
        text: "The company cannot be held responsible for circumstances beyond its control, including weather conditions, flight cancellations, strikes, governmental decisions, security situations, pandemics, and force majeure events. We will always do our best to assist clients and partners."
      },
      {
        title: "B2B Business Model",
        text: "We work exclusively with travel agencies, tour operators, companies, organized groups, and VIP clients. The final commercial relationship with travelers remains under the responsibility of the selling agency or partner."
      }
    ],
    summary: {
      kicker: "Terms & Responsibility",
      title: "Important Information",
      text: "Morocco Loves You operates as a professional B2B DMC company providing ground services in Morocco. International flights, travel insurance, medical insurance, airline delays, food-related medical incidents, and force majeure events are not included in our responsibility. Tips for drivers and guides are not included and are customarily up to €2.5 per traveler per day. Our team provides 24/7 assistance throughout the stay.",
      buttonText: "Read Full Service Policy",
      route: "/service-policy"
    }
  },
  hero: {
    welcome: "Welcome to Morocco.",
    welcomeHome: "Welcome Home.",
    subtitle: "Private luxury tours, authentic experiences,",
    subtitleLine2: "and full personal service across Morocco —",
    subtitleGold: "personally handled by the CEO.",
    whatsappBtn: "Chat with Ilan (CEO) Now on WhatsApp",
    badgeFast: "Fast response",
    badgePersonal: "Personal service",
    badge247: "24/7 availability",
    limitedAvail: "Limited availability",
    personalizedOnly: "Personalized trips only"
  },
  strip: {
    privateTours: "Private Tours",
    localExperts: "Local Experts",
    bestHotels: "Best Hotels",
    luxuryTransport: "Luxury Transport",
    satisfaction: "100% Satisfaction"
  },
  cta: {
    whatsapp: "Chat with Ilan (CEO) Now on WhatsApp",
    whatsappFloating: "Chat on WhatsApp",
    whatsappInquiry: "Hello, I'm interested in a premium Morocco travel experience."
  },
  home: {
    vipBannerTitle: "VIP Morocco Travel Experiences",
    vipBannerText: "Exclusive access, private drivers, and luxury accommodations tailored for discerning travelers.",
    vipBannerBtn: "Discover VIP Services",
    wcBadge: "🇲🇦 Morocco World Cup 2030",
    wcTitle: "Morocco 2030",
    wcText: "Exclusive World Cup travel packages combining football, Moroccan culture, VIP hospitality, and luxury experiences.",
    wcBtn: "View Packages",
    galleryTitle: "Gallery",
    gallerySubtitle: "A glimpse into your future Moroccan journey",
    exploreDestination: "Explore destination",
    featuredToursTitle: "Featured Tours & Packages",
    featuredToursSubtitle: "Carefully curated experiences for the perfect Moroccan adventure",
    viewAllTours: "View All Tours",
    culinaryTitle: "Our Food - The Best In The World",
    culinarySubtitle: "Experience Moroccan Culinary Excellence 🍲",
    culinaryBtn: "Discover Culinary Experiences",
    culinaryIntro: "At Morocco Loves You, dining is not just about eating. It is a journey into the heart of Moroccan culture. We offer authentic, hand-picked culinary experiences — from traditional home-cooked meals to high-end Moroccan gastronomy, all prepared with love and the freshest local ingredients.",
    culinaryVideoTitle: "Culinary Experience Videos",
    culinaryFeatures: [
      "Traditional Tagines",
      "Authentic Couscous",
      "Moroccan Pastries",
      "Tea Ceremonies",
      "Cooking Classes",
      "Local Spices",
      "Organic Ingredients",
      "Home-cooked Meals"
    ],
    videoTitle: "RECOMMENDATIONS",
    unityQuote: "Morocco Loves You welcomes all cultures, all beliefs, and all peoples.",
    unityAlt: "Morocco Loves You Unity Banner",
    testimonialsTitle: "What Our VIP Guests Say",
    testimonialsSubtitle: "Real reviews from international travelers",
    readMoreReviews: "Read More Reviews",
    viewAllTransport: "View All Transport",
    transportTitle: "Our VIP Transportation & Drivers",
    transportSubtitle: "Luxury, Comfort & Safety Across Morocco 🌍",
    transportIntro: "At Morocco Loves You, transportation is not just about moving from one place to another. It is part of the experience. We provide modern, clean, comfortable, and fully air-conditioned vehicles across Morocco — with professional drivers, warm hospitality, and VIP service from the very first moment."
  },
  tours: {
    pageTitle: "Tours & Packages",
    pageSubtitle: "Choose from our carefully curated Morocco tour packages",
    sectionTitle: "Our Tour Packages",
    sectionIntro: "From desert adventures to coastal escapes, we have the perfect package for every traveler",
    howToBook: "How to Book",
    step1Title: "Choose a Tour",
    step1Text: "Browse our packages and select the one that suits you best",
    step2Title: "Click Book Now",
    step2Text: 'Click the "Book Now" button on your chosen tour',
    step3Title: "Fill Details",
    step3Text: "Provide your travel dates and personal information",
    step4Title: "Confirmation",
    step4Text: "Receive confirmation and itinerary details via email",
    customTitle: "Need a Custom Package?",
    customText: "Contact us to create a personalized Morocco tour experience",
    customBtn: "Get in Touch",
    days: "Days",
    highlights: "Highlights:",
    bookNow: "Book Now",
    highlightsLabel: "HIGHLIGHTS:",
    viewFullDetails: "View Full Details",
    viewDetails: "View Details",
    premiumPackage: "Premium Package",
    arrival: "Arrival:",
    route: "Route:",
    flights: "Flights:",
    transportation: "Transportation:",
    hotels: "Hotels:",
    foodDining: "Food & Dining:",
    whatsIncluded: "What's Included:",
    attractionsExperiences: "Attractions & Experiences:",
    itinerary: "Itinerary:",
    optionalExperiences: "Optional Experiences:",
    availableUponRequest: "Available Upon Request:",
    specialSaharaExperience: "Special Sahara Experience:",
    suitableFor: "Suitable For:",
    importantNotes: "Important Notes:",
    priceInformation: "Price Information:",
    priceWarningText: "Prices may change depending on flight prices, exchange rates, holidays, seasons, and hotel availability.",
    safetyComfort: "Safety & Comfort:",
    safetyText: "We work in coordination with Moroccan authorities and security services to ensure the safety and comfort of our guests.",
    safetyTextBrief: "Coordinated with Moroccan authorities for your safety.",
    givesMore: "Morocco Loves You gives more:",
    givesMoreText: "More love, care, professionalism, joy, and safety. Easy and relaxing tours with real human hospitality.",
    givesMoreBrief: "Morocco Loves You:",
    givesMoreTextBrief: "More love, care, and professionalism.",
    bookThisPackage: "Book This Package",
    backToPackages: "Back to Packages",
    premiumMoroccoPackages: "Premium Morocco Packages",
    premiumMoroccoPackagesDesc: "Exclusive, carefully curated experiences for our discerning guests.",
    suitable: {
      couples: "Couples",
      families: "Families",
      groups: "Groups",
      solo: "Solo travelers",
      seniors: "Seniors",
      companies: "Companies",
      agencies: "Travel agencies",
      operators: "Tour operators"
    },
    pkg1: {
      title: "Europe/Morocco Luxury Weekend Escape",
      duration: "3 Nights / 4 Days ",
      price: "€790",
      hl1: "Direct roundtrip flights included (London/Europe)",
      hl2: "4–5 star luxury hotels",
      hl3: "Traditional Moroccan hammam",
      hl4: "Cooking & art workshops",
      hl5: "Moroccan live performances",
      hl1_brief: "Direct roundtrip flights included",
      subtitle: "All-Inclusive Package – From A to Z",
      flight1: "Direct roundtrip flights",
      flight2: "20kg checked luggage",
      flight3: "Cabin luggage up to 8kg",
      inc1: "Airport pickup & transfer back",
      inc2: "4–5 star hotels (Half board)",
      inc3: "Fresh & authentic Moroccan cuisine",
      inc4: "Traditional tea & pastries experience",
      inc5: "Professional tour guide & Private driver",
      inc6: "Modern air-conditioned transportation",
      inc7: "Special live performances (Singers & dancers)",
      inc7_brief: "Special live performances",
      inc8: "Traditional market tours (Spice, Lantern, Carpet)",
      inc8_brief: "Traditional market tours",
      inc9: "Cooking & Art workshops (Pre-booking required)",
      inc9_brief: "Cooking & Art workshops",
      inc10: "Natural springs & Viewpoints visits",
      inc11: "Day trips to Chefchaouen & Ifrane",
      inc12: "Visits with local Moroccan families",
      inc13: "Surprise experiences during the tour",
      suit1: "Couples",
      suit2: "Families",
      suit3: "Groups",
      suit4: "Solo travelers",
      suit5: "Seniors",
      suit6: "Companies",
      suit7: "Travel agencies",
      suit8: "Tour operators"
    },
    pkg2: {
      title: "Morocco Luxury Discovery Tour",
      duration: "6 Nights / 7 Days ",
      price: "€1490",
      hl1: "Package A",
      hl2: "Atlas Mouvements",
      hl3: "Marakech- Essaouira - Merzouga - Ouarzazte - Marakech-",
      hl4: "Big Surprise ❤️",
      hl5: "Package B",
      subtitle: "Fes & North Morocco Route (All Inclusive)",
      routeText: "2 nights Fes, 1 night Chefchaouen, 1 night Tangier, 1 night Ifrane, 1 final night Fes",
      flight1: "Direct roundtrip flights from Europe",
      flight2: "20kg luggage + Cabin luggage",
      trans1: "Airport pickup & transfer",
      trans2: "Private professional driver & tour guide",
      trans3: "New air-conditioned vehicles",
      hotel1: "4–5 star hotels",
      hotel2: "Premium locations",
      hotel3: "High-level service",
      food1: "Half board",
      food2: "Authentic cuisine",
      food3: "Traditional tea & pastries",
      exp1: "Moroccan live performances",
      exp2: "Traditional markets (Spice, Lantern, Carpet)",
      exp2_brief: "Traditional markets",
      exp3: "Traditional Moroccan hammam",
      exp4: "Nature & forest visits",
      exp4_brief: "Nature visits",
      exp5: "Beautiful viewpoints & Day trips",
      exp6: "Cooking & art workshops",
      exp7: "Visits with local families",
      exp8: "Special surprises during the trip",
      suit1: "Couples",
      suit2: "Families",
      suit3: "Groups",
      suit4: "Solo travelers",
      suit5: "Seniors",
      suit6: "Companies",
      suit7: "Travel agencies"
    },
    pkg3: {
      title: "Morocco Grand Experience",
      duration: "10 Nights / 11 Days ",
      price: "€1990",
      hl1: "Full premium ground services",
      hl2: "Casablanca, Marrakech & Fes",
      hl3: "Agadir & Sahara desert surprises",
      hl4: "Visit Ouarzazate & Chefchaouen",
      hl5: "Special live music & performances",
      subtitle: "✨ Morocco Grand Experience (Ground Services Only)",
      arrivalText: "Casablanca or Marrakech",
      routeText: "Casablanca, Rabat, 2 nights Fes, Tangier, Chefchaouen, Ifrane, 2 nights Marrakech, Agadir, Ouarzazate, final night Marrakech",
      note2: "Groups > 40: Special discount of $50 per person",
      note3: "International flights & insurance NOT included",
      note4: "Tips for driver/guide NOT included",
      inc1: "Full premium ground services",
      inc2: "4–5 star hotels (Half board)",
      inc3: "Professional tour guide & Private driver",
      inc4: "Air-conditioned bus or minibus",
      inc5: "Live performances & music atmosphere",
      inc6: "Traditional markets & Hammam visits",
      inc7: "Cooking & art workshops",
      inc8: "Excursions to forests, springs & viewpoints",
      inc9: "Visits with local families",
      inc10: "Special surprises during the journey"
    },
    pkg4: {
      title: "LUXURY MOROCCO EXPERIENCE",
      duration: "16 Nights / 17 Days",
      price: "All Inclusive",
      hl1: "Casablanca • Rabat • Fez • Tangier • Chefchaouen",
      hl2: "Ifrane • Merzouga Sahara Desert",
      hl3: "Essaouira • Ourika & Atlas Mountains • Marrakesh",
      hl3_brief: "Visit Atlas Mountains",
      hl4: "2 Nights Luxury Desert Camp with Camel & Jeep Tours",
      hl5: "Magical Sunrise & Sunset • Sleep Under The Stars",
      subtitle: "✨ Morocco Imperial & Sahara Experience - The Complete Journey (16 Nights / 17 Days)",
      routeText: "Casablanca (1 night), Rabat, Fez (2 nights), Tangier (1 night), Chefchaouen (1 night), Ifrane (1 night), Merzouga Sahara (2 nights), Essaouira (2 nights), Ourika & Atlas Mountains (1 night), Marrakesh (3 nights)",
      inc1: "4★ / 5★ Hotels",
      inc2: "Luxury Air-Conditioned Desert Camp",
      inc2_brief: "4–5 star hotels",
      inc3: "Full Board / Premium Moroccan Cuisine",
      inc3_brief: "Professional tour guide",
      inc4: "Professional Multilingual Guides",
      inc4_brief: "Special live performances",
      inc5: "Private Modern Transportation",
      inc5_brief: "Traditional markets",
      inc6: "Air-Conditioned Coaches",
      inc7: "WiFi • TV • Refrigerator On Board",
      inc8: "Private Driver Throughout The Tour",
      inc9: "Camel Tours",
      inc10: "Jeep Desert Experience",
      inc11: "Folklore Shows & Live Music",
      inc12: "Moroccan Dance Performances",
      inc13: "Cooking Workshops",
      inc14: "Markets & Souks Experiences",
      inc15: "Carpets • Spices • Flowers • Traditional Crafts",
      inc16: "Lakes • Rivers • Atlas Mountains",
      inc17: "Special Sunrise & Sunset Experiences",
      inc18: "Direct 24/7 Support",
      optional1: "Hot Air Balloon Experience",
      optional2: "VIP Upgrades",
      optional3: "Luxury Experiences",
      optional4: "Private Security Services",
      optional5: "Medical Assistance Services",
      optionalNote: "Some premium services may require an additional fair supplement.",
      sahara1: "Premium air-conditioned desert tents",
      sahara2: "Campfire music atmosphere",
      sahara3_brief: "Jeep excursions & Camel rides",
      itinerary1: "Casablanca - Arrival (1 Night)",
      itinerary2: "Rabat - The Royal Capital",
      itinerary3: "Fez - Spiritual & Cultural Morocco (2 Nights)",
      itinerary4: "Tangier - Where Europe Meets Africa (1 Night)",
      itinerary5: "Chefchaouen - The Blue Pearl (1 Night)",
      itinerary6: "Ifrane - The Moroccan Switzerland (1 Night)",
      itinerary7: "Merzouga Sahara Desert (2 Nights) - Luxury Desert Camp - Camel Experience - Jeep Tours - Magical Sunrise & Sunset - Sleeping Under The Stars",
      itinerary8: "Essaouira - Atlantic Ocean Escape (2 Nights)",
      itinerary9: "Ourika & Atlas Mountains (1 Night)",
      itinerary10: "Marrakesh - The Red City (3 Nights)"
    }
  },
  destinations: {
    pageTitle: "Explore Morocco's Destinations",
    pageSubtitle: "Discover incredible places to visit across beautiful Morocco",
    sectionTitle: "All Destinations",
    sectionIntro: "Morocco is a country of diverse landscapes and rich cultural heritage. Explore our carefully selected destinations:",
    exploreNow: "Explore Now",
    ctaTitle: "Ready to Plan Your Trip?",
    ctaText: "Browse our curated tours and packages to find the perfect Moroccan experience",
    ctaBtn: "View Tours & Packages"
  },
  experiences: {
    pageTitle: "Moroccan Culinary Excellence",
    pageSubtitle: "Discover our food — the best in the world",
    bookViaWhatsApp: "Book via WhatsApp",
    introTitle: "Our Unique Moroccan Culinary Experience",
    introHighlight: "Authentic flavors, fresh ingredients, centuries of tradition, and unforgettable hospitality.",
    introP1: "Welcome to the authentic flavors of Morocco.",
    introP2: "At Morocco Loves You, food is not just a meal — it is culture, history, family, hospitality, and love.",
    introP3: "For centuries, Moroccan cuisine has been considered one of the richest, healthiest, and most flavorful cuisines in the world.",
    introP4: "Our culinary traditions combine Arab, Berber, Jewish Moroccan, Andalusian, Mediterranean, and African influences — creating unique recipes preserved for more than 500 years.",
    prepTitle: "The Art of Moroccan Preparation",
    prepP1: "Everything is prepared with care, passion, fresh local ingredients, and authentic Moroccan spices.",
    prepP2: "We carefully select trusted restaurants, authentic local experiences, and quality culinary destinations for our guests.",
    prepP3: "Morocco is known worldwide for its colorful markets, fresh agriculture, natural products, spices, olives, oranges, pastries, mint tea, and unforgettable hospitality.",
    journeyVideos: "Culinary Journey Videos",
    highlightsTitle: "Traditional Culinary Highlights",
    highlightTagine: "Authentic Moroccan Tagine",
    highlightCouscous: "Traditional Couscous",
    highlightVegetables: "Fresh vegetables & natural ingredients",
    highlightPastries: "Homemade pastries & desserts",
    highlightBreakfasts: "Traditional Moroccan breakfasts",
    highlightMeat: "Fresh fish & quality meats",
    highlightJuices: "Natural juices & Moroccan tea",
    highlightHealthy: "Healthy and delicious cooking traditions",
    galleryTitle: "Our Culinary Gallery",
    summaryP1: "Our goal is to offer our guests not only a trip — but a true Moroccan culinary journey.",
    tagHealthy: "Healthy",
    tagAuthentic: "Authentic",
    tagTraditional: "Traditional",
    tagFresh: "Fresh",
    tagUnique: "Unique",
    tagDelicious: "Delicious",
    important: "Important:",
    guidanceNote: "For the best culinary experience, we strongly recommend following the guidance of our team and culinary recommendations during your journey in Morocco.",
    whereMeal: "Where every meal becomes a memory.",
    whatsappLabel: "WhatsApp: +972 54-633-8757",
    moroccoLine: "Morocco Line: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "VIP & Business Travel",
    pageSubtitle: "Exclusive services for CEOs, investors, and discerning travelers",
    introTitle: "Seamless Excellence in Morocco",
    introText: "MoroccoLovesYou provides an unparalleled standard of service for business travelers, corporate delegations, and VIP guests. We understand that your time is valuable and your standards are uncompromising. From touchdown to departure, we handle every detail with precision, allowing you to focus on your business objectives while we deliver a flawless Moroccan experience.",
    ctaTitle: "Direct Access to the CEO",
    ctaText: "For urgent inquiries and highly specialized requests, speak directly with our Founder & CEO, Ilan Hatchuel.",
    ctaBtn: "Contact Ilan Now",
    luxuryTransport: "Luxury Transport",
    luxuryTransportDesc: "VIP airport transfers and private bilingual drivers available 24/7 with luxury vehicles (Mercedes S-Class, V-Class).",
    premiumAccom: "Premium Accommodations",
    premiumAccomDesc: "Exclusive bookings at 5-star hotels, luxury riads, or private villas suited for executives and their teams.",
    businessConcierge: "Business Concierge",
    businessConciergeDesc: "Full meeting assistance, private dining reservations, and specialized itineraries for corporate retreats.",
    securityPrivacy: "Security & Privacy",
    securityPrivacyDesc: "Discreet service, secure environments, and absolute confidentiality for high-profile individuals and celebrities.",
    support247: "24/7 Support",
    support247Desc: "Direct contact with the CEO and a dedicated team ready to assist you at any time during your stay.",
    customItineraries: "Custom Itineraries",
    customItinerariesDesc: "Tailored travel plans perfectly balancing your business obligations with premium Moroccan cultural experiences."
  },
  worldcup: {
    pageTitle: "Morocco 2030 World Cup",
    pageSubtitle: "Exclusive VIP Packages & Travel Experiences for the Biggest Football Event",
    limitedBadge: "Limited Availability",
    introTitle: "The Ultimate Football Journey",
    introText: "In 2030, Morocco will co-host the FIFA World Cup, bringing the world's most prestigious sporting event to North Africa. MoroccoLovesYou is proud to offer exclusive, all-inclusive luxury travel packages designed for fans who demand the absolute best in comfort, access, and experience.",
    packagesTitle: "Premium World Cup Packages",
    silverTitle: "Silver Package",
    silverSub: "The Essential Experience",
    goldTitle: "Gold Package",
    goldSub: "The Luxury Experience",
    mostPopular: "Most Popular",
    diamondTitle: "Diamond VIP",
    diamondSub: "The Ultimate Experience",
    inquireWhatsApp: "Inquire via WhatsApp",
    ctaTitle: "Secure Your Place Before Prices Rise",
    ctaText: "Due to extremely high international demand, we highly recommend securing your VIP package early. Accommodations in host cities will sell out.",
    ctaBtn: "Contact Us Today",
    silverF1: "Premium Riad / 4-Star Hotel Accommodation",
    silverF2: "Pre-planned Match Day Logistics",
    silverF3: "Guided City Tours (Host Cities)",
    silverF4: "24/7 Dedicated Support Line",
    goldF1: "5-Star Hotel / Luxury Villa Accommodation",
    goldF2: "Private Airport & Match Transfers",
    goldF3: "VIP Desert Camp Getaway (2 Days)",
    goldF4: "Personal Bilingual Concierge",
    diamondF1: "Presidential Suites / Private Palaces",
    diamondF2: "24/7 Private Chauffeur & Security",
    diamondF3: "Exclusive Access to VIP Events & Parties",
    diamondF4: "Direct CEO Handling & VVIP Concierge"
  },
  gallery: {
    pageTitle: "Our Gallery",
    pageSubtitle: "Visual memories of unforgettable Moroccan journeys",
    picturesTitle: "Morocco in Pictures",
    picturesIntro: "Explore our collection of breathtaking photos from Morocco",
    videosTitle: "Morocco in Motion",
    videosIntro: "Experience Morocco through our curated video collection",
    catFood: "Culinary Experience",
    catDestinations: "Destinations",
    catKosher: "Kosher",
    catTransport: "VIP Transportation"
  },
  testimonials: {
    pageTitle: "Guest Testimonials",
    pageSubtitle: "Read what our travelers have to say about their Moroccan experience",
    sectionTitle: "Our Happy Travelers",
    sectionIntro: "Thousands of satisfied guests have experienced the magic of Morocco with us",
    verifiedGuest: "Verified Guest",
    ratingsTitle: "Our Ratings",
    avgRating: "Average Rating",
    verifiedReviews: "Verified Reviews",
    fromReal: "From real travelers",
    custSatisfaction: "Customer Satisfaction",
    wouldRecommend: "Would recommend",
    shareTitle: "Share Your Experience",
    shareText: "Had an amazing trip with us? We'd love to hear about it!",
    shareBtn: "Tell Us Your Story"
  },
  blog: {
    pageTitle: "Travel Blog",
    pageSubtitle: "Stories, tips, and guides for your Moroccan adventure",
    sectionTitle: "Latest Travel Articles",
    sectionIntro: "Read our latest articles about traveling in Morocco, local culture, and insider tips",
    readMore: "Read More →",
    by: "By",
    newsletterTitle: "Subscribe to Our Newsletter",
    newsletterText: "Get the latest travel tips and exclusive offers delivered to your inbox",
    newsletterPlaceholder: "Enter your email",
    subscribe: "Subscribe"
  },
  contact: {
    pageTitle: "Contact Us 24/7",
    pageSubtitle: "Get in touch with our team to plan your VIP Morocco adventure",
    getInTouch: "Contact Us",
    getInTouchText: "We're here to help and answer any questions you might have. Our team is ready to assist you in planning your perfect Morocco trip.",
    address: "Our Address",
    addressText: "53 Mohammed V Street, Fes, Morocco",
    phone: "Phone Numbers 📞",
    directPhone: "Direct Phone: +212 6 63 63 05 79",
    whatsappPhone: "WhatsApp: +972 54 633 8757",
    email: "Professional Email Addresses",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Sales@MoroccoLovesYou.com",
      "Michael@MoroccoLovesYou.com",
      "Kim@MoroccoLovesYou.com"
    ],
    businessHours: "Business Hours",
    businessHoursText: "Available 24/7\n7 Days a Week",
    responseTime: "We will get back to you within 48 hours.",
    welcomeMessage: "Welcome to Morocco 🇲🇦",
    followUs: "Follow Us",
    formTitle: "Send us a Message",
    successMessage: "✓ Thank you! We'll get back to you soon.",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    phoneNumber: "Phone Number",
    subject: "Subject",
    selectSubject: "Select a subject",
    tourInquiry: "Tour Inquiry",
    bookingQuestion: "Booking Question",
    customPackage: "Custom Package",
    feedback: "Feedback",
    other: "Other",
    message: "Details / Message",
    sendMessage: "Send Message",
    mapTitle: "Find Us on the Map",
    faqTitle: "Frequently Asked Questions",
    faq1Q: "What is the best time to visit Morocco?",
    faq1A: "Spring (April-May) and Fall (September-October) offer the best weather. Summer is hot in the desert, while winter is mild but can be rainy.",
    faq2Q: "Do I need a visa to visit Morocco?",
    faq2A: "Visa requirements depend on your nationality. Many countries have visa-free entry for up to 90 days. Check with your local embassy.",
    faq3Q: "What currency is used in Morocco?",
    faq3A: "The Moroccan Dirham (MAD) is the official currency. ATMs are widely available in cities, and most places accept credit cards.",
    faq4Q: "What language is spoken in Morocco?",
    faq4A: "Arabic and Berber (Amazigh) are official languages. French is widely spoken, and English is increasingly common in tourist areas.",
    faq5Q: "Is Morocco safe for tourists?",
    faq5A: "Yes, Morocco is generally safe for tourists. Common sense precautions apply. Our guides ensure you have a safe and enjoyable experience.",
    faq6Q: "Can I customize my tour package?",
    faq6A: "Absolutely! We offer custom packages tailored to your interests, budget, and travel dates. Contact us to discuss your requirements."
  },
  about: {
    pageTitle: "About MoroccoLovesYou",
    pageSubtitle: "Your trusted partner in discovering the magic of Morocco",
    storyTitle: "Our Story",
    storyP1: "MoroccoLovesYou was founded with a simple mission: to help travelers experience the authentic beauty, culture, and hospitality of Morocco. What started as a small travel guide service has grown into a comprehensive tourism company serving thousands of visitors annually.",
    storyP2: "Our founder, Fatima Hassan, fell in love with Morocco and wanted to share this passion with the world. Today, we pride ourselves on creating personalized, authentic experiences that go beyond typical tourism.",
    missionTitle: "🎯 Our Mission",
    missionText: "To provide exceptional travel experiences that showcase Morocco's rich cultural heritage, stunning landscapes, and warm hospitality while supporting local communities and sustainable tourism practices.",
    visionTitle: "🌟 Our Vision",
    visionText: "To be the leading Morocco tourism company known for authenticity, reliability, and creating unforgettable memories for every traveler who chooses to explore this magnificent country with us.",
    whyTitle: "Why Choose MoroccoLovesYou?",
    expertTitle: "Expert Knowledge",
    expertText: "Our team has extensive knowledge of Morocco and provides personalized recommendations.",
    localTitle: "Local Connections",
    localText: "We work with authentic local guides and families to ensure genuine experiences.",
    valueTitle: "Best Value",
    valueText: "Competitive pricing without compromising on quality and experience.",
    safetyTitle: "Safety & Support",
    safetyText: "24/7 customer support and comprehensive travel insurance included.",
    sustainTitle: "Sustainable Tourism",
    sustainText: "We support local communities and practice responsible tourism.",
    bookingTitle: "Easy Booking",
    bookingText: "Simple online booking process with flexible payment options.",
    teamTitle: "Our Team",
    teamSubtitle: "Meet the passionate people behind MoroccoLovesYou",
    happyTravelers: "Happy Travelers",
    yearsExp: "Years Experience",
    destinationsCount: "Destinations",
    satisfactionRate: "Satisfaction Rate"
  },
  footer: {
    description: "Discover the magic of Morocco with us. Experience unforgettable adventures and create lasting memories.",
    quickLinks: "Quick Links",
    more: "More",
    contactInfo: "Contact Info",
    copyright: "© 2024 MoroccoLovesYou. All rights reserved."
  },
  starBanner: {
    ceoMessage: "CEO MESSAGE",
    watchVideo: "Watch my video",
    readMessage: "& read my message",
    getToKnow: "Get to know",
    ilanPersonally: "Ilan personally"
  },
  tourMini: {
    days: "10 DAYS",
    nights: "/ 9 NIGHTS",
    title: "PREMIUM MOROCCO\nTOUR",
    years: "2026 - 2027",
    departures: "MONTHLY DEPARTURES",
    allIncluded: "ALL INCLUDED\nFULL BOARD",
    recommendations: "Recommendations",
    recCount: "500+ happy travelers"
  },
  cityDetail: {
    notFound: "City not found",
    backHome: "Back to Home",
    discoverSubtitle: "Discover the beauty and culture",
    planTrip: "Plan My Trip to",
    galleryOf: "Gallery of",
    bookExperience: "Book This Experience",
    requestItinerary: "Request Full Itinerary",
    readyToVisit: "Ready to Visit",
    readyToVisitText: "Let us plan your perfect journey to this amazing destination",
    planMyTrip: "Plan My Trip",
    talkExpert: "Talk to an Expert"
  },
  transportation: {
    pageTitle: "VIP Transportation & Drivers",
    pageSubtitle: "Luxury, Comfort & Safety Across Morocco",
    introTitle: "Our VIP Transportation & Drivers",
    introP1: "At Morocco Loves You, transportation is not just about moving from one place to another.",
    introP2: "It is part of the experience.",
    introP3: "We provide modern, clean, comfortable, and fully air-conditioned vehicles across Morocco — with professional drivers, warm hospitality, and VIP service from the very first moment.",
    introP4: "Whether you travel as a couple, family, business delegation, or private group, we make sure your journey is safe, relaxing, and unforgettable.",
    servicesTitle: "Our Transportation Services Include",
    servicesList: [
      "Modern VIP buses",
      "Luxury minibuses",
      "Private cars",
      "4x4 Jeeps for desert adventures",
      "VIP limousines",
      "Airport pickup & drop-off",
      "Professional multilingual drivers",
      "Comfortable air conditioning",
      "Clean and organized vehicles",
      "Refrigerators in selected vehicles",
      "TV & entertainment systems",
      "Music during the journey",
      "Safe and smooth driving",
      "24/7 assistance across Morocco"
    ],
    featureList: [
      "Modern VIP buses",
      "Luxury minibuses",
      "Private cars",
      "4x4 Jeeps",
      "Airport pickup",
      "Multilingual drivers",
      "24/7 assistance",
      "Safe driving"
    ],
    driversTitle: "Meet Our Drivers",
    driversText1: "Our drivers are part of the Morocco Loves You family.",
    driversText2: "Professional, respectful, experienced, and always ready to help with a smile.",
    driversText3: "Many of our drivers speak multiple languages and know Morocco deeply — helping our guests feel comfortable, safe, and connected throughout the journey.",
    safetyTitle: "Safety & Comfort First",
    safetyText1: "Your comfort and safety are our top priorities.",
    safetyText2: "All vehicles are regularly maintained, cleaned, and carefully prepared before every trip.",
    safetyText3: "We work only with trusted professional drivers and high-quality transportation partners.",
    categories: {
      buses: "VIP Buses",
      minibuses: "Luxury Minibuses",
      cars: "Private Cars & VIP Transfers",
      jeeps: "4x4 Jeeps & Desert Transportation",
      meetDrivers: "Meet Our Drivers",
      videos: "Transportation Experience Videos"
    },
    videoGalleryTitle: "VIP Experience Videos",
    ctaTitle: "Ready To Explore Morocco In Comfort?",
    ctaSubtitle: "Speak Directly With Allan – CEO & Founder",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Morocco Direct Line: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Luxury Kosher Tours In Morocco",
    pageSubtitle: "Authentic Jewish Heritage, 100% Kosher Cuisine, Luxury Hospitality & Unique Morocco Experiences.",
    introTitle: "Luxury Jewish Heritage Experience",
    introHeading: "Discover Authentic Jewish Morocco",
    introText: "Discover the deep roots of Jewish history in Morocco with an elegant, authentic, and premium travel experience. We specialize in providing a seamless journey for Jewish communities worldwide, focusing on heritage, connection, and absolute comfort.",
    introQuote: "\"Morocco is a land of tolerance and coexistence, where Jewish heritage is preserved with love and respect.\"",
    experiencesTitle: "Our Kosher Experiences Include",
    experiencesList: [
      "100% Kosher Food & Restaurants",
      "Private Kosher Chef Available",
      "Traditional Moroccan Jewish Cuisine",
      "Luxury 4 & 5-Star Hotels",
      "Private VIP Transportation",
      "Multilingual Professional Guides",
      "Jewish Heritage & Synagogue Tours",
      "Jewish Cemeteries & Museums",
      "Sahara Desert & Hammam Experiences",
      "24/7 Professional Assistance"
    ],
    expFood: "100% Kosher Food",
    expRestaurant: "Kosher Restaurant",
    expChef: "Private Kosher Chef Available",
    expCuisine: "Traditional Moroccan Jewish Cuisine",
    expHotels: "Luxury Hotels 4 & 5 Stars",
    expDeluxeHotels: "Deluxe Hotels Available Upon Request",
    expTransport: "Private VIP Transportation",
    expDrivers: "Professional Drivers",
    expAC: "Air-Conditioned Vehicles",
    expWifi: "WiFi, TV & Refrigerators In Selected Vehicles",
    expGuides: "Multilingual Professional Guides",
    expStaff: "Hebrew / English / French / Spanish / Russian / German Speaking Staff",
    expHeritage: "Jewish Heritage Tours",
    expSynagogues: "Ancient Synagogues",
    expCemeteries: "Jewish Cemeteries",
    expMuseums: "Jewish Museums",
    expSpiritual: "Spiritual & Cultural Experiences",
    expDesert: "Sahara Desert Experiences",
    expHammam: "Moroccan Hammam Experiences",
    expAttractions: "Unique Attractions Across Morocco",
    expAssistance: "24/7 Assistance",
    packagesTitle: "Flexible Kosher Travel Packages",
    packagesIntro: "We customize every trip according to the needs, traditions, travel style, dates, and expectations of our guests.",
    packageOptions: ["4–5 Days", "7–8 Days", "10–11 Days", "13–14 Days", "21 Days", "Tailor-Made Private Tours"],
    package4_5: "4–5 Days",
    package7_8: "7–8 Days",
    package10_11: "10–11 Days",
    package13_14: "13–14 Days",
    package21: "21 Days",
    packageTailor: "Tailor-Made Private Tours",
    packagesQuote: "“We customize every trip according to the needs, traditions, travel style, dates, and expectations of our guests.”",
    safetyTitle: "Comfortable, Professional & Safe Travel",
    safetyText: "Our tours operate with high attention to comfort, organization, service quality, and professional coordination across Morocco.",
    safetyQuote: "“Our tours operate with high attention to comfort, organization, service quality, and professional coordination across Morocco.”",
    b2bTitle: "B2B Jewish Travel Partnerships",
    b2bText: "We partner with Jewish communities, synagogues, rabbis, and kosher tour operators worldwide to create meaningful heritage journeys.",
    b2bPartnersList: "We work with: Jewish communities, Synagogues, Rabbis, Jewish organizations, Kosher tour operators, and Travel agencies worldwide.",
    partnerBtn: "Partner With Us",
    galleryTitle: "Kosher Experience Gallery",
    videosTitle: "Featured Videos",
    ctaTitle: "Ready to Begin Your Journey?",
    msgAllan: "Message Allan on WhatsApp",
    callMorocco: "Call Morocco: +212 6 63 63 05 79",
    ceoContact: "Speak With Allan Hatchuel Directly On WhatsApp",
    exploreBtn: "Explore Kosher Tours"
  },

  // Accessibility & UI Labels
  aria: {
    selectLanguage: "Select language",
    closeDetails: "Close details",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    kosherTravel: "Kosher Travel Morocco",
    watchVideo: "Watch Magic Morocco Video",
    followInstagram: "Follow us on Instagram",
    followFacebook: "Follow us on Facebook",
    ceoMessage: "CEO of Morocco Loves You",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagram",
    facebookSocial: "Facebook",
    logoAlt: "MoroccoLovesYou logo",
    kingAlt: "King of Morocco",
    kosherOptionsAlt: "Kosher options",
    moroccoLandscape: "Morocco landscape",
    worldCupAlt: "World Cup trophy with Moroccan flag",
    b2bBannerAlt: "B2B only tour banner - click to WhatsApp",
    starAlt: "Star",
    playVideo: "Play",
    pauseVideo: "Pause",
    vipBus: "VIP bus",
    drivers: "Our drivers",
    jewishHeritageArchitecture: "Jewish heritage architecture",
    jewishHeritageMorocco: "Jewish heritage Morocco",
    kosherFoodMorocco: "Kosher food Morocco",
    jewishHeritageExperience: "Jewish heritage experience",
    kosherMoroccanTable: "Kosher Moroccan table",
    luxuryHospitality: "Luxury hospitality",
    kosherExperience: "Kosher experience"
  },
  
  // Form Placeholders
  forms: {
    firstName: "e.g. John",
    lastName: "e.g. Doe",
    email: "name@example.com",
    subject: "How can we help?",
    message: "Tell us more about your travel plans...",
    phone: "Your phone number",
    date: "Select a date",
    guests: "Number of guests"
  },
  
  // Common UI Text
  common: {
    selectLanguage: "Select language",
    instagram: "Instagram",
    facebook: "Facebook",
    loading: "Loading...",
    error: "An error occurred",
    success: "Success!",
    noResults: "No results found",
    viewMore: "View More",
    viewLess: "View Less",
    bookNow: "Book Now",
    learnMore: "Learn More",
    contactUs: "Contact Us",
    close: "Close",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search...",
    filter: "Filter",
    sort: "Sort",
    price: "Price",
    duration: "Duration",
    languages: {
      english: "English",
      american: "American",
      australia: "Australia",
      canada: "Canada",
      french: "French",
      spanish: "Spanish",
      hebrew: "Hebrew",
      arabic: "العربية",
      german: "German",
      italian: "Italian",
      japanese: "Japanese",
      chinese: "Chinese",
      korean: "Korean",
      vietnamese: "Vietnamese",
      russian: "Russian",
      en: "English",
      "en-US": "American",
      "en-AU": "Australia",
      "en-CA": "Canada",
      fr: "French",
      es: "Spanish",
      he: "Hebrew",
      ar: "العربية",
      de: "German",
      it: "Italian",
      ja: "Japanese",
      zh: "Chinese",
      ko: "Korean",
      vi: "Vietnamese",
      ru: "Russian"
    }
  },
  
  // WhatsApp Message Templates
  whatsapp: {
    greeting: "Hello Morocco Loves You! 🌟",
    bookPackage: "I'd like to book the following package:",
    packageInfo: "📦 Package: ",
    duration: "⏱️ Duration: ",
    price: "💰 Price: ",
    bookingRequest: "Please let me know the availability and next steps. Thank you!",
    cityTrip: "I'd like to plan a trip to {city}. Can you help me?",
    silverPackage: "I'm interested in the Silver World Cup Package",
    goldPackage: "I'm interested in the Gold World Cup Package",
    diamondPackage: "I'm interested in the Diamond World Cup VIP Package",
    worldCupSecure: "Hello, I want to secure my place for Morocco 2030.",
    kosherInquiry: "I'm interested in your Kosher Morocco travel packages.",
    customPackage: "I'd like to create a custom package for our group.",
    businessInquiry: "I'm interested in VIP Business Travel services."
  },
  
  // Blog Posts
  blog_posts: {
    post1: {
      title: "10 Hidden Gems to Discover in Morocco",
      author: "Fatima Hassan",
      date: "March 15, 2024",
      category: "Travel Guide",
      excerpt: "Discover the lesser-known destinations and hidden treasures of Morocco that most tourists miss. From secret mountain villages to pristine coastal areas, explore authentic Morocco.",
      content: "Morocco is far more than just Marrakech and Casablanca. This comprehensive guide reveals hidden gems..."
    },
    post2: {
      title: "Best Time to Visit Morocco: A Complete Guide",
      author: "Ahmed Bennani",
      date: "March 10, 2024",
      category: "Planning",
      excerpt: "Planning your Morocco trip? Learn about the best seasons to visit, what to expect weather-wise, and how to make the most of your journey throughout the year.",
      content: "Choosing the right time to visit Morocco can significantly impact your travel experience. Here's our complete guide..."
    },
    post3: {
      title: "Moroccan Cuisine: A Culinary Adventure",
      author: "Layla Rahim",
      date: "March 5, 2024",
      category: "Food & Culture",
      excerpt: "Embark on a culinary journey through Morocco. Discover the rich flavors, traditional recipes, and dining experiences that make Moroccan food world-famous.",
      content: "Moroccan cuisine is a blend of Arab, Berber, Andalusian, and African influences. Each dish tells a story of Morocco's diverse heritage..."
    },
    post4: {
      title: "How to Haggle in Moroccan Markets Like a Pro",
      author: "Youssef Alaoui",
      date: "February 28, 2024",
      category: "Travel Tips",
      excerpt: "Master the art of haggling in Moroccan souks and markets. Learn the cultural etiquette, negotiation tactics, and insider tips for getting the best deals.",
      content: "Haggling is not just a transaction in Moroccan markets; it's a cultural exchange. Here's how to do it respectfully and effectively..."
    },
    post5: {
      title: "Trekking the Atlas Mountains: What You Need to Know",
      author: "Ahmed Bennani",
      date: "February 20, 2024",
      category: "Adventure",
      excerpt: "Explore the majestic Atlas Mountains on foot. Get expert advice on trekking routes, what to pack, altitude considerations, and the best time for your mountain adventure.",
      content: "The Atlas Mountains offer some of the most breathtaking landscapes in North Africa. Whether you're a seasoned hiker or a beginner..."
    },
    post6: {
      title: "Desert Safari: An Unforgettable Experience",
      author: "Fatima Hassan",
      date: "February 15, 2024",
      category: "Adventure",
      excerpt: "Experience the magic of Morocco's Sahara Desert. Camel trekking, starry nights under canvas tents, and sunrise moments you'll never forget.",
      content: "The Sahara Desert represents the soul of Morocco. A desert safari is more than just an adventure; it's a spiritual journey..."
    },
    post7: {
      title: "Cultural Etiquette: Respecting Moroccan Traditions",
      author: "Layla Rahim",
      date: "February 10, 2024",
      category: "Culture",
      excerpt: "Learn the essential cultural norms, customs, and etiquette for respectfully engaging with Moroccan people and traditions during your visit.",
      content: "Understanding and respecting local customs is crucial when traveling to Morocco. This guide covers essential cultural practices..."
    },
    post8: {
      title: "Photography in Morocco: Capturing the Magic",
      author: "Youssef Alaoui",
      date: "February 5, 2024",
      category: "Photography",
      excerpt: "Discover the most photogenic locations in Morocco and professional tips for capturing stunning images of landscapes, people, and culture.",
      content: "Morocco is a photographer's paradise. From the blue medinas to golden deserts, every corner offers incredible photo opportunities..."
    }
  },
  
  // Job Listings
  jobs: {
    title: "Careers & Opportunities",
    intro: "Join the MoroccoLovesYou team and build your future in luxury travel",
    workWith: "Work With Love, Care & Excellence",
    introText: "We're looking for passionate, dedicated individuals who share our vision of delivering world-class travel experiences. Join our growing team and be part of something special.",
    openPositions: "Open Positions",
    requirements: "Requirements:",
    readyJoin: "Ready to Join Us?",
    sendCV: "Send your CV to careers@moroccolovesyou.com",
    instructions: "Include a brief cover letter explaining why you'd like to join the Morocco Loves You team.",
    emailCv: "Email CV to CEO",
    chatCeo: "Chat with CEO on WhatsApp",
    
    job1: {
      title: "Multilingual Professional Tour Guide",
      type: "Full-Time / Seasonal",
      location: "Marrakech / Fes / Morocco-wide",
      description: "We are looking for passionate, knowledgeable, and storytelling guides who can bring Morocco to life for our VIP guests. Your role involves leading premium tours, sharing cultural insights, and ensuring guest satisfaction.",
      req1: "Fluent in at least 2 languages (French, Spanish, English, Hebrew, German, Russian, or Italian preferred)",
      req2: "Deep knowledge of Moroccan history, culture, and geography",
      req3: "Professional, personable, and excellent customer service skills",
      req4: "Physical fitness for desert trekking and outdoor activities"
    },
    job2: {
      title: "VIP Executive Driver",
      type: "Full-Time",
      location: "Morocco-wide",
      description: "Join our luxury transport team driving modern high-end Mercedes vehicles. You'll provide VIP transfers, ensure guest comfort and safety, and represent our brand with professionalism and hospitality.",
      req1: "Valid driver's license with excellent driving record (10+ years experience preferred)",
      req2: "Fluency in English (additional languages a plus)",
      req3: "Professional appearance and courteous demeanor",
      req4: "Knowledge of Morocco's roads and routes; GPS/navigation experience"
    },
    job3: {
      title: "Customer Experience Coordinator",
      type: "Full-Time",
      location: "Remote / Hybrid (Fes Office)",
      description: "Support our CEO office in organizing luxury custom itineraries, managing guest communications, and ensuring seamless travel coordination. This role is ideal for organized, detail-oriented professionals.",
      req1: "Excellent organizational and communication skills",
      req2: "Experience with travel, hospitality, or customer service",
      req3: "Fluent in English; additional languages a bonus",
      req4: "Proficiency with booking systems and Microsoft Office Suite"
    }
  },
  
  // Testimonials
  testimonials_data: {
    intro: "Meet our satisfied guests who have experienced Morocco through our services",
    
    testi1: {
      name: "Sarah Johnson",
      title: "London, UK",
      rating: 5,
      text: "Morocco Loves You made my dream trip a reality! Every detail was perfectly organized, from luxury hotels to authentic experiences. The service is unmatched. I'm already planning my return visit!",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    },
    testi2: {
      name: "Michael Chen",
      title: "Singapore",
      rating: 5,
      text: "As a business traveler, I was impressed by the professionalism and customization. VIP treatment from day one, personalized itinerary, and impeccable logistics. Highly recommended for executive travel.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi3: {
      name: "Emma Wilson",
      title: "Sydney, Australia",
      rating: 5,
      text: "The desert experience was magical! Sleeping under the stars, camel trekking, and the warmth of Moroccan hospitality exceeded all expectations. Thank you for creating lifelong memories!",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi4: {
      name: "James Rodriguez",
      title: "Madrid, Spain",
      rating: 5,
      text: "Family trip planning can be stressful, but Morocco Loves You handled everything brilliantly. Safe, educational, and fun for all ages. Our kids still talk about the medina visits!",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi5: {
      name: "Anna Mueller",
      title: "Berlin, Germany",
      rating: 5,
      text: "I appreciated the cultural authenticity and respect shown to local traditions. This wasn't just tourism; it was a genuine cultural immersion. Bravo to the entire team!",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi6: {
      name: "David Thompson",
      title: "Toronto, Canada",
      rating: 5,
      text: "The accessibility for seniors was exceptional. Comfortable pacing, supportive guides, and luxury accommodations made my grandparents incredibly happy. A service that truly cares.",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
    },
    testi7: {
      name: "Lisa Anderson",
      title: "New York, USA",
      rating: 5,
      text: "Food lover here! The culinary experiences were exquisite. Every meal told a story, every guide showed genuine passion. Morocco's flavors will stay with me forever.",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80"
    },
    testi8: {
      name: "Marcus Smith",
      title: "Los Angeles, USA",
      rating: 5,
      text: "Adventure-packed yet luxurious – exactly what I was looking for. Atlas trekking, desert safaris, all with VIP comfort. Worth every penny!",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d"
    },
    testi9: {
      name: "Sophie Laurent",
      title: "Paris, France",
      rating: 5,
      text: "Romance trip extraordinaire! Sunset in the Sahara, private dinners overlooking Marrakech, and attentive service throughout. Morocco Loves You truly lives up to their name.",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330"
    }
  },
  
  // Gallery Categories
  gallery_categories: {
    food: "Culinary Experience",
    destinations: "Destinations",
    kosher: "Kosher",
    transport: "VIP Transportation"
  },
  
  // Stats
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  }
};

export default en;
